import React from 'react';
import Link from '../WrappedLink';

export default function Breadcrumb(props) {
  const numberOfItems = React.Children.count(props.children);

  const basePath = props.basePath || '';

  return (
    <nav className="breadcrumb" aria-label="breadcrumbs">
      <ul>
        {React.Children.map(props.children, (item, i) => React.cloneElement(item, {
          last: i + 1 === numberOfItems,
          to: `${basePath}${item.props.to}`,
        }))}
      </ul>
    </nav>
  );
}

export function BreadcrumbItem(props) {
  return (
    <li className={props.last ? 'is-active' : ''}>
      <Link to={props.to}>{props.children}</Link>
    </li>
  );
}
